/**
 * memoized function wrapper
 */
function memoized(options) {
    let cache = {};

  if (typeof options.handler !== "function" || typeof options.toString !== "function")
    throw new Error("Memoized: You need to provide a handler and a toString function");

  const wrapped = (...args) => {
    const handle = options.toString(...args);
    if (handle in cache) return cache[handle];

    cache[handle] = options.handler(...args);
    return cache[handle];
  };

  wrapped.clear = function() {
    cache = [];
  };

  return wrapped;
}

export default memoized;
